export const BaseLineThumbup = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.8 8.80001V5.20002C13.8 4.11829 13.1639 3.18515 12.2453 2.75425C11.6174 2.4597 10.985 2.97476 10.7858 3.63908C10.5129 4.54884 10.0718 5.85627 9.49988 7.00012C8.49988 9.00012 7.5 10.6 7.5 10.6V20.5H17.958C18.8555 20.5102 19.6235 19.8575 19.758 18.97L21 10.87C21.0792 10.3479 20.9252 9.81726 20.5787 9.41876C20.2322 9.02026 19.7281 8.79401 19.2 8.80001H13.8Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M7.5 10.5003H5.097C4.04266 10.4816 3.14135 11.355 3 12.3999V18.6999C3.14135 19.7449 4.04266 20.5186 5.097 20.4999H7.5V10.5003Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
